// logger.ts
import pino from 'pino';

import { getLogLevel } from '@/logger/log-level.ts';
import { logManager } from '@/logger/log-manager.ts';

const levelToLabel = {
  10: 'trace',
  20: 'debug',
  30: 'info',
  40: 'warn',
  50: 'error',
  60: 'fatal',
} as const;

const levelToStyle = {
  10: 'background-color: #007bff; color: #fff',
  20: 'background-color: #17a2b8; color: #fff',
  30: 'background-color: #28a745; color: #fff',
  40: 'background-color: #ffc107; color: #fff',
  50: 'background-color: #dc3545; color: #fff',
  60: 'background-color: #6c757d; color: #fff',
} as const;

export const logger = pino({
  browser: {
    asObject: true,
    write: ({ level, msg, error, time, module, ...rest }: any) => {
      // common log
      console.log(
        `%c[${levelToLabel[level as 10].toUpperCase()}]%c ${dayjs(time).format('HH:mm:ss.SSS')}%c tintin:${module ?? 'app'}`,
        `${levelToStyle[level as 10]};border-radius: 4px;font-weight: bold;padding: 2px 6px;`,
        'color: #999;',
        'font-weight: bold;',
        msg,
      );

      // error log
      if (error instanceof Error) {
        console.groupCollapsed(
          `%c tintin:${module ?? 'app'}:Error: ${error.message}`,
          'color:#dc3545;font-weight:bold;',
        );
        console.error(error); // Full stack trace here, expands when collapsed
        console.groupEnd();
      }

      // extra log
      if (Object.keys(rest).length > 0) {
        console.groupCollapsed(
          `%c tintin:${module ?? 'app'}:Info`,
          'color:#999;',
        );
        console.trace(rest);
        console.groupEnd();
      }

      // sync log
      logManager.add({
        level: levelToLabel[level as 10].toLowerCase(),
        msg,
        error,
        time,
        module,
        ...rest,
      });
    },
  },

  level: getLogLevel(),
  timestamp: pino.stdTimeFunctions.isoTime,
});

export default logger;
